import {
  classifyNIS2Entity,
  type ClassificationResult,
} from "./nis2-classifier";
import type {
  ImpactAnalysisCalculatedResult,
  ImpactLevel,
} from "@/types/impact-analysis";
import type { SelectedService } from "@/types/service";
import type { SizeEvaluation } from "@/types";

const SIZE_MAP: Record<string, "Mare" | "Mijlocie" | "Mică"> = {
  MARE: "Mare",
  MIJLOCIE: "Mijlocie",
  MICĂ: "Mică",
};

function mapImpactLevel(
  level: ImpactLevel | null
): "RIDICAT" | "MEDIU" | "SCAZUT" | null {
  if (level === "SCĂZUT") return "SCAZUT";
  if (level === "MEDIU") return "MEDIU";
  if (level === "RIDICAT") return "RIDICAT";
  return null;
}

export function computeClassification(
  sizeEvaluation: SizeEvaluation | null,
  selectedServices: SelectedService[],
  article9Enabled: boolean,
  article9Results: ImpactAnalysisCalculatedResult
): ClassificationResult | null {
  if (!sizeEvaluation || selectedServices.length === 0) return null;

  const hasArticle9Values =
    article9Enabled &&
    (article9Results.article9a !== null ||
      article9Results.article9b !== null ||
      article9Results.article9c !== null ||
      article9Results.article9d !== null);

  return classifyNIS2Entity({
    companySize: SIZE_MAP[sizeEvaluation.size] || "Mică",
    services: selectedServices.map((s) => s.entity_id),
    establishedInRomania: true,
    providesServicesInRomania: true,
    isSoleProvider: false,
    publicImpactLevel: null,
    systemicRiskLevel: null,
    isNationalCritical: false,
    isAlreadyCriticalEntity: false,
    sectors: {
      isDNSProvider: false,
      isTLDRegistry: false,
      isQualifiedTrustProvider: false,
      isCentralPublicAdmin: false,
      energySector: [],
      transportSector: [],
      bankingSector: [],
      financialMarkets: [],
      healthSector: [],
      waterSector: [],
      digitalInfraOther: [],
      ictServiceManagement: [],
      foodSector: [],
      searchEngines: [],
      isPublicNetworkProvider: false,
      isPublicCommServiceProvider: false,
      isManagedSecurityProvider: false,
      publicAdminServices: [],
    },
    article9Override: hasArticle9Values
      ? {
          "9a": article9Results.article9a,
          "9b": mapImpactLevel(article9Results.article9b),
          "9c": mapImpactLevel(article9Results.article9c),
          "9d": article9Results.article9d,
        }
      : null,
  });
}
